<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="addProduct.show"
            hide-footer
            hide-header-close
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">เพิ่มสินค้า</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <form @submit.prevent="validateProduct()">
                    <div class="row">
                        <div class="col-lg-12">
                            <UploadImage :imageFile="addProduct.image"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ชื่อสินค้า
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ชื่อสินค้า"
                                    v-model="addProduct.name"
                                    :class="{ 'is-invalid': submitProduct && $v.addProduct.name.$error }"
                                />
                                <div
                                    class="error invalid-feedback d-block"
                                    v-if="submitProduct && !$v.addProduct.name.minLength"
                                >กรุณากรอก "ชื่อสินค้า" อย่างน้อย {{$v.addProduct.name.$params.minLength.min}} หลัก</div>
                                <div
                                    v-if="submitProduct && $v.addProduct.name.required == false"
                                    class="invalid-feedback d-block">กรุณากรอกชื่อสินค้า
                                </div> 
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ต้นทุน
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ต้นทุน"
                                    v-model="addProduct.rate"
                                    :class="{ 'is-invalid': submitProduct && $v.addProduct.rate.$error }"
                                />
                                <div
                                    v-if="submitProduct && $v.addProduct.rate.required == false"
                                    class="invalid-feedback d-block">กรุณากรอกต้นทุน
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ราคาขาย
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="ราคาขาย"
                                    v-model="addProduct.price"
                                    :class="{ 'is-invalid': submitProduct && $v.addProduct.price.$error }"
                                />
                                <div
                                    v-if="submitProduct && $v.addProduct.price.required == false"
                                    class="invalid-feedback d-block">กรุณากรอกราคาขาย
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> เลือกหมวดหมู่
                                </label>
                                <select class="form-control" v-model="addProduct.categoryId">
                                    <option :value="item.id" v-for="item in category" :key="item.code">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-12 text-center">
                            <b-button variant="outline-primary" class="px-4" @click="closeModal()">
                                ยกเลิก
                            </b-button>
                            <b-button type="submit" variant="primary" class="px-4">
                                <i class="fas fa-circle-notch fa-spin" v-if="addProduct.isLoad"></i> ยืนยัน
                            </b-button>
                        </div>
                    </div>
                </form>
            </card>
        </b-modal>
    </div>
</template>

<script>
import UploadImage from '@/components/custom/service/UploadImage'
import { createService , updateService } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { required , decimal , minLength} from "vuelidate/lib/validators";

export default {
    props:{
        category: Array,
        addProduct: Object
    },
    components:{
        UploadImage
    },
    data(){
        return{
            submitProduct: false
        }
    },
    validations: {
        addProduct: {
            name: { required, minLength: minLength(3)},
            rate: { required, decimal },
            price: { required, decimal }
        }
    },
    methods:{
        isEdit(){
            return !!this.addProduct.serviceId
        },
        closeModal(){
            this.addProduct.show = false
            this.addProduct.isLoad = false
            this.submitProduct = false; 
            this.addProduct.name = ""
            this.addProduct.rate = null
            this.addProduct.price = null
            this.addProduct.fee = null
            this.addProduct.serviceId = null
            this.addProduct.image.file = null
            this.addProduct.image.preview = null
        },
        validateProduct(){
            this.submitProduct = true
            this.$v.addProduct.$touch();
            if (this.$v.addProduct.$invalid) {
                return false
            }

            this.addProduct.fee = this.addProduct.price - this.addProduct.rate;
            this.isEdit() ? this.editProduct() : this.addProductDetail()
        },
        addProductDetail(){
            this.addProduct.isLoad = true
            createService( this.addProduct ).then( res => {
                showSuccessModal('เพิ่มสินค้าสำเร็จ')
                this.reLoadProduct()
            }).catch( error => {
                showErrorModal(error)
                this.addProduct.isLoad = false
            });
        },
        editProduct(){
            this.addProduct.isLoad = true
            updateService( this.addProduct ).then( res => {
                this.addProduct.serviceId = null
                showSuccessModal('แก้ไขสินค้าสำเร็จ')
                this.reLoadProduct()
            }).catch( error => {
                showErrorModal(error)
                this.addProduct.isLoad = false
            });
        },
        reLoadProduct(){
            this.closeModal()
            this.$emit('getApiProductDetails')
        }
    }
}
</script>